import { AnswerSummary } from 'cccisd-laravel-appdefs/dist/reportTemplates';
import Result from './result';

export default [AnswerSummary, Result];
